/* Progressive enhancement; navigation and search also work without JavaScript. */
(() => {
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = [...document.querySelectorAll('[data-mc-header] details[open]')].reverse();
    if (open.length) { open[0].open = false; open[0].querySelector('summary')?.focus(); }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-mc-header] details[open]').forEach(detail => {
      if (!detail.contains(event.target)) detail.open = false;
    });
  });
})();
